// eslint-disable-next-line
import React from 'react';
import { mdx } from 'mdx.macro';

const Content = mdx`
## תנאי השימוש

1. ארגון ”מנקים את הבית” (להלן:”הארגון”) או מי מטעמו אינו אחראי לדבר ובאחריות כל משתתף לבדוק בעצמו ולקיים לבדו ובאחריותו את מלוא התנאים הבטיחותיים, הביטחוניים והאחרים על מנת לבצע את הפעילות.
2. מובהר כי לא מדובר באירוע מתוכנן ומאורגן, כי אם בתיאום זמנים ומיקום בלבד (ולשם כך נועדה ההרשמה) בין בודדים מטעם עצמם וקבוצות מטעם עצמן בפעילות אישית אשר אינה קשורה לפעילויות אחרות ואו לאנשים ואו קבוצות כלשהן.
3. באחריותו של כל משתתף לבדוק בעצמו כי מלוא התנאים לפעילות תקינה ובטוחה – מתקיימים ובכלל כך ההגעה, העזיבה, פעולת הניקיון עצמה וכיוצ”ב.
4. הארגון או מי מטעמו לא יהיו אחראי לדבר. מלוא האחריות הינה על כל משתתף ומשתתף, ובכלל כך (אך לא מוגבל ל) סוגיות מזג אוויר, סוגיות של בטחון אישי, של תנאי שטח, של יכולת אישית, של בטיחות וכו'.
5. כל המשתתף בפעילות מוותר מראש על כל טענה כנגד הארגון או מי מטעמו ומצהיר כי הוא והוא בלבד נושא באחריות לפעילותו – על כל המשתמע מכך (ובכלל כך לכל מקרה של פגיעה בגוף ו/או בנפש). אין ולא תהיה לאף משתתף כל טענה כלפי הארגון או מי מטעמו.
`;

export default Content;
